import request from '@/utils/request'

/**
 * 查询交易日志列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryTransactionLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/transactionLog/queryTransactionLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询交易日志详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryTransactionLogMessage(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/transactionLog/queryTransactionLogMessage',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}